import { clsx } from 'clsx';

import cls from './CharItem.module.scss';

type Props = {
  label: string;
  value: string | number | undefined | null;
  onClick?: () => void;
};

export const CharItem = ({ onClick, label, value }: Props) => {
  return (
    <div className={cls.item}>
      <div className={cls.label}>{label}</div>
      <div
        className={clsx(cls.value, { [cls.accent]: onClick !== undefined })}
        onClick={onClick}
      >
        {value || ''}
      </div>
    </div>
  );
};
